/**
 * Display formatting that isn't dates or money.
 */

/**
 * File size at a resolution the user can act on.
 *
 * Always rendering megabytes reports a 40 KB receipt as "0.0 MB", which reads
 * as an empty file. The upload limit is stated in MB, so sizes near it stay in
 * MB; everything smaller drops to the unit that actually carries information.
 */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`
}
